// On a small screen the board lays the table out at a minimum size and scales it down to fit (see
// ArenaBoard's fit). Rects measured on screen are then in screen pixels, while positions inside the
// table are in its own: divide by this to go from one to the other.
export function tableScale(root: ParentNode): number {
  const table = root.querySelector<HTMLElement>(".table");
  if (!table || table.offsetWidth === 0) return 1;
  return table.getBoundingClientRect().width / table.offsetWidth || 1;
}
